<template>
    <ui-modal-info
        :name="name"
        :title="titleModal"
        sub-title="Deseja realmente efetuar a venda?"
        icon="far fa-building"
        color-circle="#24D798"
        icon-circle
        :loading="loader.overlayLoading"
        :action="submit"
        :can-submit="canSubmit"
        footer
    >
        <p>Cuidado, esta ação não poderá ser desfeita.</p>

        <div class="action-nugget">
            <ui-nugget-actions-sage-status
                v-model="action"
                action-type="make_sale"
                design="grid-2"
                nugget-id="sold-modal"
            />
        </div>

    </ui-modal-info>
</template>

<script>
    import { uiModalInfo } from '@/components/ui/modal'
    import { uiNuggetActionsSageStatus } from '@/components/ui-facilita/nuggets'

    import { reserve } from '@/services/axios'

    import { mapGetters } from 'vuex'

    const defaultFormData = () => ({
        id: null,
        expire_time: '00:00:00',
        status: 'sold'
    })

    const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: false,
		overlaySucess: false,
	})

    export default {
        name: 'sold-modal-reserves',
        components: {
            uiModalInfo,
            uiNuggetActionsSageStatus,
        },

        props: {
            name: {
                type: String,
                require: true,
                default: ''
            }
        },

        data() {
            return {
                form: {
                    data: { ...defaultFormData() }
                },
                loader: { ...defaultLoader() },
                action: {},
                eventSuccess: '',
            }
        },

        computed: {
            ...mapGetters('auth', {
                user: 'getUser'
            }),
            /**
             * Computed property que define se o formulário poder ser salvo
             */
            canSubmit() {
                return !!(this.form.data.id && 
                this.action &&
					// eslint-disable-next-line no-prototype-builtins
					this.action.hasOwnProperty('no_action') &&
					this.action.no_action
					? true
                    : this.action.action_id)
            },

            titleModal() {
				const id = this.form.data.id ? ' – #' + this.form.data.id : ''
				return 'Confirmar Venda' + id
			},
        },

        mounted() {
            this.$root.$on('modal-open-' + this.name, (data) => {
                this.reset()
               
                this.$root.$emit('clean--nugget-actions-stage-status-form-sold-modal')
                this.$root.$emit('nugget-actions-stage-status-form-sold-modal')

                if (data.deal && data.deal.id_reserve) {
                    this.form.data.id = data.deal.id_reserve
                    this.eventSuccess = data.config.eventSuccess
                }
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-' + this.name)
            this.$root.$off('nugget-actions-stage-status-form-sold-modal')
            this.$root.$off('clean--nugget-actions-stage-status-form-sold-modal')
        },

        methods: {
            /**
             * Reseta o estado do formulário para a próxima edição
             */
            reset() {
                this.$set(this.form, 'data', { ...defaultFormData() })
            },
            /**
             * Submita o formulário de modo a salvar as alterações no negócio
             */
            submit() {
                if (!this.canSubmit) return
                this.loader.overlayLoading = true
                reserve.updateV2('', this.form.data.id, { ...this.form.data, action_id: this.action.action_id })
                    .then(response => {
                        if (response.data.msg) this.$toastr.s(response.data.msg)

                        this.$root.$emit('modal-close-' + this.name)
                        this.$root.$emit(this.eventSuccess)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    }).finally(()=> {
                        this.loader.overlayLoading = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>